<template>
    <tr :class="['content-info_block-tr', isTranscodingFail ? 'disabled':'']">
        <td>
            <div class="content-info_block">
                <div class="content--info_image-wrapper">
                    <div v-if="isTranscodingFail" class="content--tr-fail_dumy-box">
                        <i class="icon icon-info-circle-line dumy-icon"/>
                    </div>
                    <TranscodingProgressCircle
                        v-if="!isTranscodingFail && !isTranscodingDone"
                        :mediaContent="mediaContent"
                    />
                    <img v-if="!isTranscodingFail" :src="mediaContent.snapshot_url" class="content--info_image">
                    <StatusPlay v-if="isTranscodingDone" @handlePreview="handlePreview"/>
                </div>
                <div class="content--info_detail">
                    <div class="content--info_name">
                        <span v-tooltip="mediaContent.title">{{ mediaContent.title }}</span>
                    </div>
                    <div class="content-info_media">
                        <template v-if="isTranscodingFail">
                            <span class="content-info_tr-fail">{{ $t('words.transcoding_fail') }}</span>
                        </template>
                        <template v-else-if="!isTranscodingFail && !isMediaInformationEmpty">
                            <div
                                v-if="mediaContent.is_passthru"
                                class="content-info_media-block content-info_media-type"
                            >
                                <span>PASSTHROUGH</span>
                            </div>
                            <div
                                v-tooltip="$t('words.audio_codec')"
                                class="content-info_media-block"
                            >
                                <span>{{ audioInformation.audio_codec }}</span>
                            </div>
                            <div
                                v-tooltip="$t('words.sample_rate')"
                                class="content-info_media-block"
                            >
                                <span>
                                    {{ audioInformation.audio_samplerate }}
                                </span>
                            </div>
                            <div
                                v-tooltip="$t('words.frame_rate')"
                                class="content-info_media-block"
                            >
                                <span>{{ videoInformation.video_framerate }}</span>
                            </div>
                            <div
                                v-tooltip="$t('words.resolution')"
                                class="content-info_media-block"
                            >
                                <span>
                                    {{ videoInformation.video_screen_size }}
                                </span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </td>
        <td class="cell--number">
            <TopLineTd>
                <div v-if="isTranscodingDone">
                    <i
                        v-if="originFileSize"
                        v-tooltip="fileSizeTooltip"
                        class="icon icon-info-circle-line content--size_info"
                    />
                    <span>{{ sumFileSize }}</span>
                </div>
            </TopLineTd>
        </td>
        <td class="cell--number">
            <TopLineTd>
                <span v-if="isTranscodingDone">
                  <span v-if="mediaContent.duration !== false">{{ mediaContent.duration }}</span>
                </span>
            </TopLineTd>
        </td>
        <td class="cell--number">
            <TopLineTd>
                <span>{{ mediaContent.created_at | renderDateTime }}</span>
            </TopLineTd>
        </td>
        <td class="cell--number">
            <TopLineTd>
                <div v-if="isReadySchedules">
                    <span>{{ readySchedulesFirstItemStartAt | renderDateTime }}</span>
                    <span v-if="readySchedulesRemainItemCount > 0"
                          v-tooltip="readySchedulesTooltip"
                          class="content--start_at">
                    +{{ readySchedulesRemainItemCount }}
                </span>
                </div>
            </TopLineTd>
        </td>
        <td class="cell--action">
            <i
                v-if="haveSubmitRight"
                v-tooltip="isReadySchedules ? $t('words.dont_delete_message'): ''"
                :class="[
                    'btn--icon',
                    'btn--icon--sm',
                    'btn--ghost',
                    !isReadySchedules ? 'btn--danger' : '',
                     isReadySchedules ? 'disabled' : ''
                ]"
                @click.prevent="doRemoveMediaContent(mediaContent)">
                <i :class="[
                    'icon',
                    'icon-trash',
                    isReadySchedules ? 'disabled' : ''
                ]"/>
            </i>
        </td>
    </tr>
</template>

<script>
import TranscodingProgressCircle
    from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/TranscodingProgressCircle';
import TopLineTd from '@/components/cms/common/Content/ContentBodyTable/TopLineTd';
import { mapActions } from 'vuex';
import StatusPlay from '@/components/cms/common/Content/ContentBodyTable/MediaContentsStatus/StatusPlay';
import ContentListItemMixin from '@/components/mixin/ContentListItemMixin';

export default {
    name: 'MediaContentsTableRow',
    mixins: [
        ContentListItemMixin,
    ],
    components: {
        StatusPlay,
        TranscodingProgressCircle,
        TopLineTd,
    },
    methods: {
        ...mapActions({
            fetchPreviewUrl: 'preview/fetchPreviewUrl',
        }),
        doRemoveMediaContent(mediaContent) {
            if (this.isReadySchedules) {
                return;
            }
            this.$emit('doRemoveMediaContent', mediaContent);
        },
        async handlePreview() {
            const payload = {
                title: this.mediaContent.title,
                mediaContentId: this.mediaContent.id,
                profileKey: this.mediaContent.transcoding_file.profile_key,
            };
            await this.fetchPreviewUrl(payload);

            $('#previewModal').modal({});
        },
    },
};
</script>
